import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography, alpha } from "@mui/material";
import { ReactComponent as ExpandMoreIcon } from "../../../assets/icons/arrow.svg";

export default function QAItem({ question, answer, id }) {
  return (
    <div>
      <Accordion
        sx={{
          py: { xxs: 0.5, sm: 1.25 },
          borderBottom: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.1)}`
        }}>
        <AccordionSummary
          sx={{
            my: 0,
            pl: 0,
            fontSize: { xxs: 12, sm: 18 },
            fontWeight: "500",
            textTransform: "uppercase",
            fontFamily: "Chakra Petch, sans-serif"
          }}
          expandIcon={<ExpandMoreIcon aria-hidden="true" />}
          aria-controls={`${id}-content`}
          id={`${id}-header`}>
          {question}
        </AccordionSummary>
        <AccordionDetails sx={{ pl: 0 }}>
          <Typography
            sx={{
              fontSize: { xxs: 12, sm: 16 },
              color: (theme) => alpha(theme.palette.text.primary, 0.6),
              whiteSpace: "pre-line",
              overflowWrap: "anywhere"
            }}>
            {answer}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
